export default __webpack_public_path__ + "static/media/playStation_store.79d02b54.png";